import Store from "@/store/index.js";
import API from "../init.js";

export default {
    async matchJoinFirst( state ) {
      try{

          const response = await API.post(
            `${"match/join/first"}`,
            {
                "deviceNumber": Store.getters.uuid,
            },
            {
              headers: {
                Authorization: "Bearer " + "test",
              },
            }
          );

          if( response?.data?.result ){
              return response?.data;
          }else{
            return false;
          }

      } catch( err ){
          console.log( err );
          alert( err.response.data.error || err.response.data.reason );
          return null;
      }

    }
}
